import React, { useEffect, useState } from "react";

const Stick = () => {
  return (
    <div class="wrapper">
      <div class="head"></div>
      <div class="torso"></div>
      <div class="leftarm"></div>
      <div class="rightarm"></div>
      <div class="leftleg"></div>
      <div class="leftfoot"></div>
      <div class="rightleg"></div>
      <div class="rightfoot"></div>
    </div>
  );
};

export default Stick;
